<unity-action-shared [action]="$action()" [disabled]="$disabled()" (clickEvent)="onOpen()" />

@let transition = $transition();
@if ($showConfirmDialog()) {
  <unity-dialog-transition-confirmation-shared
    [transition]="transition"
    (closeEvent)="onClose()"
    (transitionEvent)="onTransition($event)" />
}
